import svgComponents from './icon.js';
// console.log('icon.mixin.js svgComponents', { ...svgComponents });
export default {
	components: { ...svgComponents }
}